<template>
    <v-dialog v-model="show" persistent width="500">
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
                {{$t('selectAProject') | capitalize}}
            </v-card-title>
            <div class="pa-3 pb-5">
                <v-form @submit.prevent="submit" v-model="formValid">
                    <v-layout row justify-start align-center>
                        <div>
                            <v-radio-group v-if="projects && projects.length > 0" v-model="isNew" row>
                                <v-radio
                                    :label="$filters.capitalize($t('existed'))"
                                    :value="0"
                                ></v-radio>
                                <v-radio
                                    :label="$filters.capitalize($t('new'))"
                                    :value="1"
                                    :disabled="prepaidCount >= $const.MAX_PROJECTS"
                                ></v-radio>
                            </v-radio-group>
                        </div>
                        <v-tooltip bottom v-if="prepaidCount >= $const.MAX_PROJECTS">
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" class="pb-1" small>mdi-help-circle</v-icon>
                            </template>
                            <span>{{$t('limitProject')}}</span>
                        </v-tooltip>
                    </v-layout>
                    <v-select
                        v-if="!isNew"
                        :label="$t('selectProjectDialog.selectExistProject')"
                        :items="projects"
                        item-text="name"
                        item-value="id"
                        v-model="projectId"
                        :rules="[formRules.ruleRequired]"
                    ></v-select>
                    <v-text-field
                        v-if="isNew"
                        :label="$t('selectProjectDialog.newProjectName')"
                        v-model="projectName"
                        :rules="formRules.projectName"
                    ></v-text-field>
                </v-form>
            </div>
            <v-divider></v-divider>
            <v-card-actions style="justify-content: flex-end;">
                <v-btn @click="close">{{$t('cancel')}}</v-btn>
                <v-btn @click="selectProject" v-if="!isNew">{{$t('select')}}</v-btn>
                <v-btn @click="createProject" v-if="isNew" :disabled="prepaidCount > $const.MAX_PROJECTS">
                    {{$t('create')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import ProjectService from '@/services/project.service'
import FormMixin from '@/modules/fptai/mixins/FormMixin'

export default {
    name: 'ProjectSelector',
    mixins: [FormMixin],
    data () {
        return {
            show: false,
            promise: null,
            isNew: 0,
            projectId: '',
            projectName: '',
            formValid: false
        }
    },
    computed: {
        ...mapState({
            projects: state => state.user.projects
        }),
        prepaidCount () {
            return this.$store.getters.prepaidProjectCount
        }
    },
    methods: {
        submit () {
            if (this.isNew) {
                this.createProject()
            } else {
                this.selectProject()
            }
        },
        selectProject () {
            if (this.formValid) {
                this.show = false
                this.promise.resolve(this.projectId)
            }
        },
        async createProject () {
            if (this.formValid) {
                this.$store.dispatch(this.$actionTypes.LOADING, true)
                try {
                    let result = await ProjectService.createProject(this.projectName)
                    this.$appService.toastSuccess(this.$t('modalCreateProject.createProjectSuccessful'))
                    this.$store.dispatch(this.$actionTypes.user.GET_PROJECTS)
                    this.promise.resolve(result.data.id)
                    this.show = false
                } catch (error) {
                    ProjectService.handleCreateProjectError(error)
                }
                this.$store.dispatch(this.$actionTypes.LOADING, false)
            }
        },
        open () {
            this.show = true
            if (this.projects.length < 1) {
                this.isNew = 1
            }
            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject }
            })
        },
        close () {
            this.show = false
        }
    }
}
</script>
